export default {
  namespaced: true,
  state: {
    // 当前生效的账户类型
    account_code: sessionStorage.getItem('account_code') || ''
  },
  mutations: {
    SET_ACCOUNTTYPE: (state, data) => {
      state.account_code = data
    }
  },
  actions: {
    setAccountType ({commit}, code) {
      commit('SET_ACCOUNTTYPE', code)
      sessionStorage.setItem('account_code',code)
    }
  }
}